import { Box,Stack,Tabs,Typography } from "@mui/material";
import Tab from '@mui/material/Tab';
import React,{ useContext,useMemo,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UserContext } from "../../context/UserContext";
import { trackEventMatomo } from '../../helpers/matomo';
import { TabPanelProps } from '../../types/helpers/types';
import Finalizadas from './Finalizadas';
import MalSucedidos from './MalSucedidos';
import Pendentes from './Pendentes';

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ListaAnalises() {
  const { userData } = useContext(UserContext);
  const { t } = useTranslation('translation');

  const [value, setValue] = useState<number>(0);

  function handleChange(_event: React.SyntheticEvent, newValue: number) {
    const tabs = ['pendentes', 'finalizadas', 'malsucedidas'];
    trackEventMatomo('plano de ação', 'click', 'aba', `análises ${tabs[newValue]}`);
    setValue(newValue);
  };


  useMemo(() => {
    if (!userData.gestorPA) {
      toast.error(`${t('ActionPlan.ListaAnalises.userIsNotActionPlanManager')}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.gestorPA]);

  if (!userData.gestorPA) {
    return (
      <Typography variant='h4' textAlign='center' color='textDisabled'>
        {t('ActionPlan.ListaAnalises.userIsNotActionPlanManager')}
      </Typography>
    );
  }

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor='secondary'
        textColor='secondary'
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label={t('ActionPlan.ListaAnalises.pendingAnalyses')} value={0} />
        <Tab label={t('ActionPlan.ListaAnalises.completedAnalyses')} value={1} />
        <Tab label={t('ActionPlan.ListaAnalises.failedActionPlans')} value={2} />
      </Tabs>
      <Stack direction='row' width='100%' spacing={5}>
        <CustomTabPanel value={value} index={0}>
          <Pendentes />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Finalizadas />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <MalSucedidos />
        </CustomTabPanel>
      </Stack>
    </>
  );
}
